var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-parallax',{staticClass:"header-parallax",attrs:{"src":_vm.headerImage(),"height":_vm.headerImageHight()}},[_c('clean-header',{attrs:{"header":_vm.header,"subheader":_vm.subheader,"nobg":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }